const wallet_type = {
    NONE: 0,
    METAMASK: 1,
    WALLETCONNECT: 2,
    ALGOSIGNER: 3,
    COINBASE: 4,
}

const local_storage_key = {
    KEY_WALLET_TYPE: 'wallet_type',
    KEY_WALLET: 'wallet',
    KEY_CONNECTED: 'connected',
    KEY_WALLETS: 'wallets',
}

const fraction_digits = {
    ETHEREUM: 8,
}

const wallet_errors = {
    CONNECTION_REJECTED: 'Connection rejected by user, please connect to wallet',
    TRANSACTION_PENDING: 'Trasaction pending, please check your wallet for transaction:',
    TRANSACTION_REJECTED: 'User denied transaction signature',
    USER_REJECTED: 'UserRejected',
    BALANCE_BELOW_MIN: 'below min',
    ASSERT_MINT: 'assert',
    NOT_ENOUGH_BALANCE_ALGO: 'tried to spend',
    NOT_ENOUGH_BALANCE: 'insufficient funds for gas',
    MAX_WALLET_LIMIT: 'maxPerWallet limit',
    NOT_MINED:
        'Transaction was not mined within 50 blocks, please make sure your transaction was properly sent. Be aware that it might still be mined!',
    MINT_PRICE: 'Mint price is not correct.',
    SALES_FINISHED: 'SalesPhase finished',
    SALES_NOT_STARTED: 'SalesPhase not started',
    SALES_NOT_EXIST: 'SalesPhase not exist',
    SALES_SOLDOUT: 'SalesPhase soldout',
    COLLECTION_SOLDOUT: 'Collection soldout',
    MAX_MINT_ALLOWED: 'Max mint allowed limit',
    INVALID_SIGNATURE: 'invalid signature',
}

const isIframe = window.location != window.parent.location

export { wallet_type, local_storage_key, fraction_digits, wallet_errors, isIframe }
